import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();
  pageable.sortField.value = 'id';

  const filters = ref({
    name: {value: null},
    sitesId: {value: []},
    enabled: {value: null},
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.name?.value != null) {
      params['name'] = filters.value.name.value;
    }

    if (filters.value.sitesId?.value?.length > 0) {
      params['sitesId'] = filters.value.sitesId.value.join(',');
    }

    if (filters.value.enabled?.value != null) {
      params['enabled'] = filters.value.enabled.value;
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


